/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { hideWhisperAction, showWhisperAction } from './whisper.actions';
import { HIDE_WHISPER, SHOW_WHISPER } from './whisper.types';

const initialState: {
    isWhisperActive: boolean;
} = {
    isWhisperActive: false,
};

const whisperReducer = (state = initialState, { type, payload } = <AnyAction>{}) => {
    switch (type) {
        case SHOW_WHISPER:
            return {
                isWhisperActive: payload.isWhisperActive,
            };
        case HIDE_WHISPER:
            return {
                isWhisperActive: payload.isWhisperActive,
            };
        default:
            return state;
    }
};

export const showWhisper = () => (dispatch: Function, getState: Function) => {
    const { isWhisperActive } = getState().whisper;
    if (!isWhisperActive) dispatch(showWhisperAction());
};

export const hideWhisper = () => (dispatch: Function, getState: Function) => {
    const { isWhisperActive } = getState().whisper;
    if (isWhisperActive) dispatch(hideWhisperAction());
};

export default whisperReducer;
